import * as React from "react";

// Custom Add Burger icon to replace PlusCircle in the bottom nav
// Uses currentColor for stroke to match theme, sized like lucide (24x24)
const AddBurgerIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    {/* Top bun */}
    <path d="M4 11c0-3 3.8-6 8-6s8 3 8 6" />
    {/* Patty */}
    <path d="M6 14h12" />
    {/* Bottom bun with slight curve */}
    <path d="M4 17c0 1.2 3.6 2 8 2s8-.8 8-2v-2H4v2z" />
  </svg>
);

export default AddBurgerIcon;
